var items = {
  "block.minecraft.air": "lug",
  "block.minecraft.stone": "klip",
  "block.minecraft.granite": "graniet",
  "block.minecraft.polished_granite": "gepoleerde graniet",
  "block.minecraft.diorite": "dioriet",
  "block.minecraft.polished_diorite": "gepoleerde dioriet",
  "block.minecraft.andesite": "andesiet",
  "block.minecraft.polished_andesite": "gepoleerde andesiet",
  "block.minecraft.grass_block": "grasblok",
  "block.minecraft.dirt": "grond",
  "block.minecraft.coarse_dirt": "growwe grond",
  "block.minecraft.podzol": "suurgrond",
  "block.minecraft.crimson_nylium": "bloedrooi laelium",
  "block.minecraft.warped_nylium": "vreemde laelium",
  "block.minecraft.cobblestone": "steengruis",
  "block.minecraft.oak_planks": "eikehout planke",
  "block.minecraft.spruce_planks": "dennehout planke",
  "block.minecraft.birch_planks": "berk planke",
  "block.minecraft.jungle_planks": "oerwoudhout planke",
  "block.minecraft.acacia_planks": "akasiahout planke",
  "block.minecraft.dark_oak_planks": "donker eikehout planke",
  "block.minecraft.crimson_planks": "bloedrooi planke",
  "block.minecraft.warped_planks": "vreemde planke",
  "block.minecraft.oak_sapling": "eikeboom stiggie",
  "block.minecraft.spruce_sapling": "denneboom stiggie",
  "block.minecraft.birch_sapling": "berkeboom stiggie",
  "block.minecraft.jungle_sapling": "mahonieboom stiggie",
  "block.minecraft.acacia_sapling": "akasiaboom stiggie",
  "block.minecraft.dark_oak_sapling": "donker eikeboom stiggie",
  "block.minecraft.bedrock": "rotsbodem",
  "block.minecraft.sand": "sand",
  "block.minecraft.red_sand": "rooi sand",
  "block.minecraft.gravel": "gruis",
  "block.minecraft.gold_ore": "gouderts",
  "block.minecraft.iron_ore": "ystererts",
  "block.minecraft.coal_ore": "steenkool erts",
  "block.minecraft.nether_gold_ore": "laer gouderts",
  "block.minecraft.oak_log": "eikehout stomp",
  "block.minecraft.spruce_log": "spar stomp",
  "block.minecraft.birch_log": "berk stomp",
  "block.minecraft.jungle_log": "oerwoudhout stomp",
  "block.minecraft.acacia_log": "akasiahout stomp",
  "block.minecraft.dark_oak_log": "donker eikehout stomp",
  "block.minecraft.crimson_stem": "bloedrooi steel",
  "block.minecraft.warped_stem": "vreemde steel",
  "block.minecraft.stripped_oak_log": "gestroopte eikehout stomp",
  "block.minecraft.stripped_spruce_log": "gestroopte spar stomp",
  "block.minecraft.stripped_birch_log": "gestroopte berk stomp",
  "block.minecraft.stripped_jungle_log": "gestroopte oerwoudhout stomp",
  "block.minecraft.stripped_acacia_log": "gestroopte akasiahout stomp",
  "block.minecraft.stripped_dark_oak_log": "gestroopte donker eikehout stomp",
  "block.minecraft.stripped_crimson_stem": "gestroopte bloedrooi steel",
  "block.minecraft.stripped_warped_stem": "gestroopte vreemde steel",
  "block.minecraft.stripped_oak_wood": "gestroopte eikehout",
  "block.minecraft.stripped_spruce_wood": "gestroopte sparhout",
  "block.minecraft.stripped_birch_wood": "gestroopte berkhout",
  "block.minecraft.stripped_jungle_wood": "gestroopte oerwoudhout",
  "block.minecraft.stripped_acacia_wood": "gestroopte akasiahout",
  "block.minecraft.stripped_dark_oak_wood": "gestroopte donker eikehout",
  "block.minecraft.stripped_crimson_hyphae": "gestroopte bloedrooi styfstrepe",
  "block.minecraft.stripped_warped_hyphae": "vreemde gestroopte skyfstrepe",
  "block.minecraft.oak_wood": "eikehout",
  "block.minecraft.spruce_wood": "dennehout",
  "block.minecraft.birch_wood": "berkehout",
  "block.minecraft.jungle_wood": "mahoniehout",
  "block.minecraft.acacia_wood": "akasiahout",
  "block.minecraft.dark_oak_wood": "donker eikehout",
  "block.minecraft.crimson_hyphae": "bloedrooi styfstrepe",
  "block.minecraft.warped_hyphae": "verwronge skyfstrepe",
  "block.minecraft.oak_leaves": "eikeblare",
  "block.minecraft.spruce_leaves": "dennenaalde",
  "block.minecraft.birch_leaves": "berkeblare",
  "block.minecraft.jungle_leaves": "mahonieblare",
  "block.minecraft.acacia_leaves": "akasiablare",
  "block.minecraft.dark_oak_leaves": "donker eikeboomblare",
  "block.minecraft.sponge": "spons",
  "block.minecraft.wet_sponge": "nat spons",
  "block.minecraft.glass": "glas",
  "block.minecraft.lapis_ore": "lasuurerts",
  "block.minecraft.lapis_block": "lasuurblok",
  "block.minecraft.dispenser": "uitdeler",
  "block.minecraft.sandstone": "sandsteen",
  "block.minecraft.chiseled_sandstone": "afgewerkte sandsteen",
  "block.minecraft.cut_sandstone": "gesnyde sandsteen",
  "block.minecraft.note_block": "nootblok",
  "block.minecraft.powered_rail": "aandrywingsspoor",
  "block.minecraft.detector_rail": "seinspoor",
  "block.minecraft.sticky_piston": "taai pompsuier",
  "block.minecraft.cobweb": "spinnerak",
  "block.minecraft.grass": "gras",
  "block.minecraft.fern": "varing",
  "block.minecraft.dead_bush": "dooie bos",
  "block.minecraft.seagrass": "seagras",
  "block.minecraft.sea_pickle": "see pickle",
  "block.minecraft.piston": "pompsuier",
  "block.minecraft.white_wool": "wit wol",
  "block.minecraft.orange_wool": "oranje wol",
  "block.minecraft.magenta_wool": "magenta wol",
  "block.minecraft.light_blue_wool": "ligblou wol",
  "block.minecraft.yellow_wool": "geel wol",
  "block.minecraft.lime_wool": "heldergroen wol",
  "block.minecraft.pink_wool": "pienk wol",
  "block.minecraft.gray_wool": "grys wol",
  "block.minecraft.light_gray_wool": "liggrys wol",
  "block.minecraft.cyan_wool": "siaan wol",
  "block.minecraft.purple_wool": "pers wol",
  "block.minecraft.blue_wool": "blou wol",
  "block.minecraft.brown_wool": "bruin wol",
  "block.minecraft.green_wool": "groen wol",
  "block.minecraft.red_wool": "rooi wol",
  "block.minecraft.black_wool": "swart wol",
  "block.minecraft.dandelion": "perdeblom",
  "block.minecraft.poppy": "papawer",
  "block.minecraft.blue_orchid": "blou orgideë",
  "block.minecraft.allium": "wilde ui",
  "block.minecraft.azure_bluet": "blou aster",
  "block.minecraft.red_tulip": "rooi tulp",
  "block.minecraft.orange_tulip": "oranje tulp",
  "block.minecraft.white_tulip": "wit tulp",
  "block.minecraft.pink_tulip": "pienk tulp",
  "block.minecraft.oxeye_daisy": "madeliefie",
  "block.minecraft.cornflower": "koringblom",
  "block.minecraft.lily_of_the_valley": "lelie van die vallei",
  "block.minecraft.wither_rose": "verwelk roos",
  "block.minecraft.brown_mushroom": "bruin sampioen",
  "block.minecraft.red_mushroom": "rooi sampioen",
  "block.minecraft.crimson_fungus": "bloedrooi swam",
  "block.minecraft.warped_fungus": "vreemde swam",
  "block.minecraft.crimson_roots": "bloedrooi wortels",
  "block.minecraft.warped_roots": "vreemde wortels",
  "block.minecraft.nether_sprouts": "laer spruite",
  "block.minecraft.weeping_vines": "huilende klimplant",
  "block.minecraft.twisting_vines": "verdraaiende klimplant",
  "block.minecraft.sugar_cane": "suikerriet",
  "block.minecraft.kelp": "kelp",
  "block.minecraft.bamboo": "bamboes",
  "block.minecraft.gold_block": "goudblok",
  "block.minecraft.iron_block": "ysterblok",
  "block.minecraft.oak_slab": "eikehout blad",
  "block.minecraft.spruce_slab": "spar blad",
  "block.minecraft.birch_slab": "berk blad",
  "block.minecraft.jungle_slab": "oerwoudhout blad",
  "block.minecraft.acacia_slab": "akasiahout blad",
  "block.minecraft.dark_oak_slab": "donker eikehout blad",
  "block.minecraft.crimson_slab": "bloedrooi blad",
  "block.minecraft.warped_slab": "vreemde blad",
  "block.minecraft.stone_slab": "klipblad",
  "block.minecraft.smooth_stone_slab": "gladde klipplaat",
  "block.minecraft.sandstone_slab": "sandsteenblad",
  "block.minecraft.cut_sandstone_slab": "sny sandsteenplaat",
  "block.minecraft.petrified_oak_slab": "versteekste eikehout blad",
  "block.minecraft.cobblestone_slab": "steengruisblad",
  "block.minecraft.brick_slab": "baksteen blad",
  "block.minecraft.stone_brick_slab": "klipsteenblad",
  "block.minecraft.nether_brick_slab": "nether baksteenblad",
  "block.minecraft.quartz_slab": "kwartsblad",
  "block.minecraft.red_sandstone_slab": "rooi sandsteenblad",
  "block.minecraft.cut_red_sandstone_slab": "sny rooi sandsteenblaar",
  "block.minecraft.purpur_slab": "purpur-blad",
  "block.minecraft.prismarine_slab": "prismaryn blad",
  "block.minecraft.prismarine_brick_slab": "prismaryn baksteen blad",
  "block.minecraft.dark_prismarine_slab": "donker prismaryn blad",
  "block.minecraft.smooth_quartz": "gladde kwarts blad",
  "block.minecraft.smooth_red_sandstone": "gladde rooi sandsteen",
  "block.minecraft.smooth_sandstone": "gladde sandsteen",
  "block.minecraft.smooth_stone": "gladde klip",
  "block.minecraft.bricks": "bakstene",
  "block.minecraft.tnt": "tnt",
  "block.minecraft.bookshelf": "boekrak",
  "block.minecraft.mossy_cobblestone": "mossige geplaveide",
  "block.minecraft.obsidian": "lawaglas",
  "block.minecraft.torch": "fakkel",
  "block.minecraft.end_rod": "endstaaf",
  "block.minecraft.chorus_plant": "refrein plant",
  "block.minecraft.chorus_flower": "refrein blom",
  "block.minecraft.purpur_block": "purpurblok",
  "block.minecraft.purpur_pillar": "purpur pilaar",
  "block.minecraft.purpur_stairs": "purpur trappe",
  "block.minecraft.spawner": "kuiter",
  "block.minecraft.oak_stairs": "eikehout trappe",
  "block.minecraft.chest": "kis",
  "block.minecraft.diamond_ore": "diamanterts",
  "block.minecraft.diamond_block": "diamantblok",
  "block.minecraft.crafting_table": "werksbank",
  "block.minecraft.farmland": "landbougrond",
  "block.minecraft.furnace": "oond",
  "block.minecraft.ladder": "leer",
  "block.minecraft.rail": "spoor",
  "block.minecraft.cobblestone_stairs": "steengruis trappe",
  "block.minecraft.lever": "skakelaar",
  "block.minecraft.stone_pressure_plate": "klip drukplaat",
  "block.minecraft.oak_pressure_plate": "eikehout drukplaat",
  "block.minecraft.spruce_pressure_plate": "spar drukplaat",
  "block.minecraft.birch_pressure_plate": "berk drukplaat",
  "block.minecraft.jungle_pressure_plate": "oerwoudhout drukplaat",
  "block.minecraft.acacia_pressure_plate": "akasiahout drukplaat",
  "block.minecraft.dark_oak_pressure_plate": "donker eikehout drukplaat",
  "block.minecraft.crimson_pressure_plate": "bloedrooi drukplaat",
  "block.minecraft.warped_pressure_plate": "vreemde drukplaat",
  "block.minecraft.polished_blackstone_pressure_plate": "gepoleerde swartsteen drukplaat",
  "block.minecraft.redstone_ore": "redstone-erts",
  "block.minecraft.redstone_torch": "redstone fakkel",
  "block.minecraft.snow": "sneeu",
  "block.minecraft.ice": "ys",
  "block.minecraft.snow_block": "sneeublok",
  "block.minecraft.cactus": "kaktus",
  "block.minecraft.clay": "klei",
  "block.minecraft.jukebox": "musiekspeler",
  "block.minecraft.oak_fence": "eikehout heining",
  "block.minecraft.spruce_fence": "dennehout heining",
  "block.minecraft.birch_fence": "berkehou heining",
  "block.minecraft.jungle_fence": "mahoniehout heining",
  "block.minecraft.acacia_fence": "akasiahout heining",
  "block.minecraft.dark_oak_fence": "donker eikehout heining",
  "block.minecraft.crimson_fence": "bloedrooi heining",
  "block.minecraft.warped_fence": "vreemde heining",
  "block.minecraft.pumpkin": "pampoen",
  "block.minecraft.carved_pumpkin": "gekerf pampoen",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "sielsand",
  "block.minecraft.soul_soil": "siel grond",
  "block.minecraft.basalt": "basalt",
  "block.minecraft.polished_basalt": "gepoleerde basalt",
  "block.minecraft.soul_torch": "sielfakkel",
  "block.minecraft.glowstone": "gloeisteen",
  "block.minecraft.jack_o_lantern": "pampoenspook",
  "block.minecraft.oak_trapdoor": "eikehout trapdoor",
  "block.minecraft.spruce_trapdoor": "spar valdeur",
  "block.minecraft.birch_trapdoor": "berk valdeur",
  "block.minecraft.jungle_trapdoor": "oerwoudhout valdeur",
  "block.minecraft.acacia_trapdoor": "akasiahout valdeur",
  "block.minecraft.dark_oak_trapdoor": "donker eikehout valdeur",
  "block.minecraft.crimson_trapdoor": "bloedrooi valdeur",
  "block.minecraft.warped_trapdoor": "vreemde valdeur",
  "block.minecraft.infested_stone": "besmette klip",
  "block.minecraft.infested_cobblestone": "besmette geplaveide",
  "block.minecraft.infested_stone_bricks": "besmette klipstene",
  "block.minecraft.infested_mossy_stone_bricks": "besmette mossige klipstene",
  "block.minecraft.infested_cracked_stone_bricks": "besmette gekraakte klipstene",
  "block.minecraft.infested_chiseled_stone_bricks": "besmette afgewerkte klipstene",
  "block.minecraft.stone_bricks": "klipstene",
  "block.minecraft.mossy_stone_bricks": "mossige klipstene",
  "block.minecraft.cracked_stone_bricks": "gekraakte klipstene",
  "block.minecraft.chiseled_stone_bricks": "afgewerkte klipstene",
  "block.minecraft.brown_mushroom_block": "bruin sampioen blok",
  "block.minecraft.red_mushroom_block": "rooi sampioen blok",
  "block.minecraft.mushroom_stem": "sampioen stengel",
  "block.minecraft.iron_bars": "yster stawe",
  "block.minecraft.chain": "ketting",
  "block.minecraft.glass_pane": "glaspaneel",
  "block.minecraft.melon": "waatlemoen",
  "block.minecraft.vine": "klimplante",
  "block.minecraft.oak_fence_gate": "eikehout hek",
  "block.minecraft.spruce_fence_gate": "dennehout hek",
  "block.minecraft.birch_fence_gate": "berkehout hek",
  "block.minecraft.jungle_fence_gate": "mahoniehout hek",
  "block.minecraft.acacia_fence_gate": "akasiahout hek",
  "block.minecraft.dark_oak_fence_gate": "donker eikehout hek",
  "block.minecraft.crimson_fence_gate": "bloedrooi hek",
  "block.minecraft.warped_fence_gate": "vreemde hek",
  "block.minecraft.brick_stairs": "baksteen trappe",
  "block.minecraft.stone_brick_stairs": "klipsteen trappe",
  "block.minecraft.mycelium": "miselium",
  "block.minecraft.lily_pad": "lelieblaar",
  "block.minecraft.nether_bricks": "nether bakstene",
  "block.minecraft.cracked_nether_bricks": "gekraakte laer bakstene",
  "block.minecraft.chiseled_nether_bricks": "afgewerkde laer bakstene",
  "block.minecraft.nether_brick_fence": "netherbaksteen heining",
  "block.minecraft.nether_brick_stairs": "nether baksteen-trappe",
  "block.minecraft.enchanting_table": "betoweringtafel",
  "block.minecraft.end_portal_frame": "laer ingang raam",
  "block.minecraft.end_stone": "endsteen",
  "block.minecraft.end_stone_bricks": "endsteen bakstene",
  "block.minecraft.dragon_egg": "draak eier",
  "block.minecraft.redstone_lamp": "redstone lamp",
  "block.minecraft.sandstone_stairs": "sandsteen trappe",
  "block.minecraft.emerald_ore": "smarag-erts",
  "block.minecraft.ender_chest": "ender kis",
  "block.minecraft.tripwire_hook": "strikdraad haak",
  "block.minecraft.emerald_block": "smaragblok",
  "block.minecraft.spruce_stairs": "spar trappe",
  "block.minecraft.birch_stairs": "berk trappe",
  "block.minecraft.jungle_stairs": "oerwoudhout trappe",
  "block.minecraft.crimson_stairs": "bloedrooi trappe",
  "block.minecraft.warped_stairs": "vreemde trappe",
  "block.minecraft.command_block": "opdragblok",
  "block.minecraft.beacon": "baken",
  "block.minecraft.cobblestone_wall": "steengruis muur",
  "block.minecraft.mossy_cobblestone_wall": "mossige steengruis muur",
  "block.minecraft.brick_wall": "baksteen muur",
  "block.minecraft.prismarine_wall": "prismarine muur",
  "block.minecraft.red_sandstone_wall": "rooi sandsteen muur",
  "block.minecraft.mossy_stone_brick_wall": "mossige steen baksteen muur",
  "block.minecraft.granite_wall": "graniet muur",
  "block.minecraft.stone_brick_wall": "klip baksteen muur",
  "block.minecraft.nether_brick_wall": "laer baksteen muur",
  "block.minecraft.andesite_wall": "andesiet muur",
  "block.minecraft.red_nether_brick_wall": "rooi laer baksteen muur",
  "block.minecraft.sandstone_wall": "sandsteen muur",
  "block.minecraft.end_stone_brick_wall": "eindbaksteen muur",
  "block.minecraft.diorite_wall": "dioriet muur",
  "block.minecraft.blackstone_wall": "swartsteenmuur",
  "block.minecraft.polished_blackstone_wall": "gepoleerde swartsteenmuur",
  "block.minecraft.polished_blackstone_brick_wall": "gepoleerde swartsteen baksteenmuur",
  "block.minecraft.stone_button": "klip knoppie",
  "block.minecraft.oak_button": "eikehout knoppie",
  "block.minecraft.spruce_button": "spar knoppie",
  "block.minecraft.birch_button": "berk knoppie",
  "block.minecraft.jungle_button": "oerwoudhout knoppie",
  "block.minecraft.acacia_button": "akasia knoppie",
  "block.minecraft.dark_oak_button": "donker eikehout knoppie",
  "block.minecraft.crimson_button": "bloedrooi knoppie",
  "block.minecraft.warped_button": "vreemde knoppie",
  "block.minecraft.polished_blackstone_button": "gepoleerde swartsteen knoppie",
  "block.minecraft.anvil": "aambeeld",
  "block.minecraft.chipped_anvil": "gekapte aambeeld",
  "block.minecraft.damaged_anvil": "beskadigde aambeeld",
  "block.minecraft.trapped_chest": "lokval kis",
  "block.minecraft.light_weighted_pressure_plate": "ligte geweegde druk plaat",
  "block.minecraft.heavy_weighted_pressure_plate": "swaar geweegde druk plaat",
  "block.minecraft.daylight_detector": "daglig sensor",
  "block.minecraft.redstone_block": "redstone-blok",
  "block.minecraft.nether_quartz_ore": "nether kwartserts",
  "block.minecraft.hopper": "geutbak",
  "block.minecraft.chiseled_quartz_block": "afgewerkde kwartsblok",
  "block.minecraft.quartz_block": "kwartsblok",
  "block.minecraft.quartz_bricks": "kwarts bakstene",
  "block.minecraft.quartz_pillar": "kwarts pilaar",
  "block.minecraft.quartz_stairs": "kwarts trappe",
  "block.minecraft.activator_rail": "skakelaarspoor",
  "block.minecraft.dropper": "leweraar",
  "block.minecraft.white_terracotta": "wit terracotta",
  "block.minecraft.orange_terracotta": "oranje terracotta",
  "block.minecraft.magenta_terracotta": "magenta terracotta",
  "block.minecraft.light_blue_terracotta": "ligblou terracotta",
  "block.minecraft.yellow_terracotta": "geel terracotta",
  "block.minecraft.lime_terracotta": "lemmetjie groen terracotta",
  "block.minecraft.pink_terracotta": "pienk terracotta",
  "block.minecraft.gray_terracotta": "grys terracotta",
  "block.minecraft.light_gray_terracotta": "liggrys terracotta",
  "block.minecraft.cyan_terracotta": "siaan terracotta",
  "block.minecraft.purple_terracotta": "pers terracotta",
  "block.minecraft.blue_terracotta": "blou terracotta",
  "block.minecraft.brown_terracotta": "bruin terracotta",
  "block.minecraft.green_terracotta": "groen terracotta",
  "block.minecraft.red_terracotta": "rooi terracotta",
  "block.minecraft.black_terracotta": "swart terracotta",
  "block.minecraft.barrier": "versperring",
  "block.minecraft.iron_trapdoor": "yster valdeur",
  "block.minecraft.hay_block": "hooibaal",
  "block.minecraft.white_carpet": "wit mat",
  "block.minecraft.orange_carpet": "oranje mat",
  "block.minecraft.magenta_carpet": "magenta mat",
  "block.minecraft.light_blue_carpet": "ligblou mat",
  "block.minecraft.yellow_carpet": "geel mat",
  "block.minecraft.lime_carpet": "heldergroen mat",
  "block.minecraft.pink_carpet": "pienk mat",
  "block.minecraft.gray_carpet": "grys mat",
  "block.minecraft.light_gray_carpet": "liggrys mat",
  "block.minecraft.cyan_carpet": "siaan mat",
  "block.minecraft.purple_carpet": "pers mat",
  "block.minecraft.blue_carpet": "blou mat",
  "block.minecraft.brown_carpet": "bruin mat",
  "block.minecraft.green_carpet": "groen mat",
  "block.minecraft.red_carpet": "rooi mat",
  "block.minecraft.black_carpet": "swart mat",
  "block.minecraft.terracotta": "terracotta",
  "block.minecraft.coal_block": "steenkoolblok",
  "block.minecraft.packed_ice": "gepakte ys",
  "block.minecraft.acacia_stairs": "akasiahout trappe",
  "block.minecraft.dark_oak_stairs": "donker eikehout trappe",
  "block.minecraft.slime_block": "slymblok",
  "block.minecraft.grass_path": "gras pad",
  "block.minecraft.sunflower": "sonneblom",
  "block.minecraft.lilac": "tuinsering",
  "block.minecraft.rose_bush": "roosbos",
  "block.minecraft.peony": "pinksterroos",
  "block.minecraft.tall_grass": "hoë gras",
  "block.minecraft.large_fern": "groot varing",
  "block.minecraft.white_stained_glass": "wit glas",
  "block.minecraft.orange_stained_glass": "oranje glas",
  "block.minecraft.magenta_stained_glass": "magenta glas",
  "block.minecraft.light_blue_stained_glass": "ligblou glas",
  "block.minecraft.yellow_stained_glass": "geel glas",
  "block.minecraft.lime_stained_glass": "heldergroen glas",
  "block.minecraft.pink_stained_glass": "pienk glas",
  "block.minecraft.gray_stained_glass": "grys glas",
  "block.minecraft.light_gray_stained_glass": "liggrys glas",
  "block.minecraft.cyan_stained_glass": "siaan glas",
  "block.minecraft.purple_stained_glass": "pers glas",
  "block.minecraft.blue_stained_glass": "blou glas",
  "block.minecraft.brown_stained_glass": "bruin glas",
  "block.minecraft.green_stained_glass": "groen glas",
  "block.minecraft.red_stained_glass": "rooi glas",
  "block.minecraft.black_stained_glass": "swart glas",
  "block.minecraft.white_stained_glass_pane": "wit gekleurde glaspaneel",
  "block.minecraft.orange_stained_glass_pane": "oranje gekleurde glaspaneel",
  "block.minecraft.magenta_stained_glass_pane": "magenta gekleurde glaspaneel",
  "block.minecraft.light_blue_stained_glass_pane": "ligblou gekleurde glaspaneel",
  "block.minecraft.yellow_stained_glass_pane": "geel gekleurde glaspaneel",
  "block.minecraft.lime_stained_glass_pane": "liggroen gekleurde glaspaneel",
  "block.minecraft.pink_stained_glass_pane": "pienk gekleurde glaspaneel",
  "block.minecraft.gray_stained_glass_pane": "grys gekleurde glaspaneel",
  "block.minecraft.light_gray_stained_glass_pane": "liggrys gekleurde glaspaneel",
  "block.minecraft.cyan_stained_glass_pane": "siaan gekleurde glaspaneel",
  "block.minecraft.purple_stained_glass_pane": "pers glaspaneel",
  "block.minecraft.blue_stained_glass_pane": "blou glaspaneel",
  "block.minecraft.brown_stained_glass_pane": "bruin glaspaneel",
  "block.minecraft.green_stained_glass_pane": "groen glaspaneel",
  "block.minecraft.red_stained_glass_pane": "rooi glaspaneel",
  "block.minecraft.black_stained_glass_pane": "swart glaspaneel",
  "block.minecraft.prismarine": "prismaryn",
  "block.minecraft.prismarine_bricks": "prismaryn bakstene",
  "block.minecraft.dark_prismarine": "donker prismaryn",
  "block.minecraft.prismarine_stairs": "prismaryn trappe",
  "block.minecraft.prismarine_brick_stairs": "prismaryn baksteen trappe",
  "block.minecraft.dark_prismarine_stairs": "donker prismaryn trappe",
  "block.minecraft.sea_lantern": "see lantern",
  "block.minecraft.red_sandstone": "rooi sandsteen",
  "block.minecraft.chiseled_red_sandstone": "afgewerkte rooi sandsteen",
  "block.minecraft.cut_red_sandstone": "gesnyde rooi sandsteen",
  "block.minecraft.red_sandstone_stairs": "rooi sandsteen trappe",
  "block.minecraft.repeating_command_block": "herhalende opdragblok",
  "block.minecraft.chain_command_block": "ketting opdragblok",
  "block.minecraft.magma_block": "magmablok",
  "block.minecraft.nether_wart_block": "netherwortelblok",
  "block.minecraft.warped_wart_block": "vreemde vrat blok",
  "block.minecraft.red_nether_bricks": "rooi nether bakstene",
  "block.minecraft.bone_block": "beenblok",
  "block.minecraft.structure_void": "struktuur leemte",
  "block.minecraft.observer": "waarnemer",
  "block.minecraft.shulker_box": "shulker boks",
  "block.minecraft.white_shulker_box": "wit shulker boks",
  "block.minecraft.orange_shulker_box": "oranje shulker boks",
  "block.minecraft.magenta_shulker_box": "magenta shulker boks",
  "block.minecraft.light_blue_shulker_box": "ligte blou shulker boks",
  "block.minecraft.yellow_shulker_box": "geel shulker boks",
  "block.minecraft.lime_shulker_box": "lemmetjie groen shulker boks",
  "block.minecraft.pink_shulker_box": "pienk shulker boks",
  "block.minecraft.gray_shulker_box": "grys shulker boks",
  "block.minecraft.light_gray_shulker_box": "ligte grys shulker boks",
  "block.minecraft.cyan_shulker_box": "siaan shulkerboks",
  "block.minecraft.purple_shulker_box": "pers shulker boks",
  "block.minecraft.blue_shulker_box": "blou shulker boks",
  "block.minecraft.brown_shulker_box": "bruin shulker boks",
  "block.minecraft.green_shulker_box": "groen shulker boks",
  "block.minecraft.red_shulker_box": "rooi shulker boks",
  "block.minecraft.black_shulker_box": "swart shulker boks",
  "block.minecraft.white_glazed_terracotta": "wit geglasuurde terracotta",
  "block.minecraft.orange_glazed_terracotta": "oranje geglasuurde terracotta",
  "block.minecraft.magenta_glazed_terracotta": "magenta geglasuurde terracotta",
  "block.minecraft.light_blue_glazed_terracotta": "ligte blou geglasuurde terracotta",
  "block.minecraft.yellow_glazed_terracotta": "geel geglasuurde terracotta",
  "block.minecraft.lime_glazed_terracotta": "lemmetjie groen geglasuurde terracotta",
  "block.minecraft.pink_glazed_terracotta": "pienk geglasuurde terracotta",
  "block.minecraft.gray_glazed_terracotta": "grys geglasuurde terracotta",
  "block.minecraft.light_gray_glazed_terracotta": "ligte grys geglasuurde terracotta",
  "block.minecraft.cyan_glazed_terracotta": "siaan geglasuurde terracotta",
  "block.minecraft.purple_glazed_terracotta": "pers geglasuurde terracotta",
  "block.minecraft.blue_glazed_terracotta": "blou geglasuurde terracotta",
  "block.minecraft.brown_glazed_terracotta": "bruin geglasuurde terracotta",
  "block.minecraft.green_glazed_terracotta": "groen geglasuurde terracotta",
  "block.minecraft.red_glazed_terracotta": "rooi geglasuurde terracotta",
  "block.minecraft.black_glazed_terracotta": "swart geglasuurde terracotta",
  "block.minecraft.white_concrete": "wit beton",
  "block.minecraft.orange_concrete": "oranje beton",
  "block.minecraft.magenta_concrete": "magenta beton",
  "block.minecraft.light_blue_concrete": "ligte blou beton",
  "block.minecraft.yellow_concrete": "geel beton",
  "block.minecraft.lime_concrete": "lemmetjie groen beton",
  "block.minecraft.pink_concrete": "pienk beton",
  "block.minecraft.gray_concrete": "grys beton",
  "block.minecraft.light_gray_concrete": "ligte grys beton",
  "block.minecraft.cyan_concrete": "siaan beton",
  "block.minecraft.purple_concrete": "pers beton",
  "block.minecraft.blue_concrete": "blou beton",
  "block.minecraft.brown_concrete": "bruin beton",
  "block.minecraft.green_concrete": "groen beton",
  "block.minecraft.red_concrete": "rooi beton",
  "block.minecraft.black_concrete": "swart beton",
  "block.minecraft.white_concrete_powder": "wit beton poeier",
  "block.minecraft.orange_concrete_powder": "oranje beton poeier",
  "block.minecraft.magenta_concrete_powder": "magenta beton poeier",
  "block.minecraft.light_blue_concrete_powder": "ligblou beton poeier",
  "block.minecraft.yellow_concrete_powder": "geel beton poeier",
  "block.minecraft.lime_concrete_powder": "lemmetjie groen beton poeier",
  "block.minecraft.pink_concrete_powder": "pienk beton poeier",
  "block.minecraft.gray_concrete_powder": "grys beton poeier",
  "block.minecraft.light_gray_concrete_powder": "liggrys beton poeier",
  "block.minecraft.cyan_concrete_powder": "siaan beton poeier",
  "block.minecraft.purple_concrete_powder": "pers beton poeier",
  "block.minecraft.blue_concrete_powder": "blou beton poeier",
  "block.minecraft.brown_concrete_powder": "bruin beton poeier",
  "block.minecraft.green_concrete_powder": "groen beton poeier",
  "block.minecraft.red_concrete_powder": "rooi beton poeier",
  "block.minecraft.black_concrete_powder": "swart beton poeier",
  "block.minecraft.turtle_egg": "skilpad eier",
  "block.minecraft.dead_tube_coral_block": "dooie buis koraal blok",
  "block.minecraft.dead_brain_coral_block": "dooie brein koraal blok",
  "block.minecraft.dead_bubble_coral_block": "dooie borrel koraal blok",
  "block.minecraft.dead_fire_coral_block": "dooie vuur koraal blok",
  "block.minecraft.dead_horn_coral_block": "dooie horing koraal blok",
  "block.minecraft.tube_coral_block": "tube coral block",
  "block.minecraft.brain_coral_block": "brein koraal blok",
  "block.minecraft.bubble_coral_block": "borrel koraal blok",
  "block.minecraft.fire_coral_block": "vuur koraal blok",
  "block.minecraft.horn_coral_block": "horing koraal blok",
  "block.minecraft.tube_coral": "buise koraal",
  "block.minecraft.brain_coral": "brein koraal",
  "block.minecraft.bubble_coral": "borrel koraal",
  "block.minecraft.fire_coral": "coral de fogo",
  "block.minecraft.horn_coral": "coral horn",
  "block.minecraft.dead_brain_coral": "coral cérebro morto",
  "block.minecraft.dead_bubble_coral": "coral da bolha morta",
  "block.minecraft.dead_fire_coral": "coral de fogo morto",
  "block.minecraft.dead_horn_coral": "coral do chifre morto",
  "block.minecraft.dead_tube_coral": "coral tubo morto",
  "block.minecraft.tube_coral_fan": "tubo coral fan",
  "block.minecraft.brain_coral_fan": "fã coral do cérebro",
  "block.minecraft.bubble_coral_fan": "ventilador do coral da bolha",
  "block.minecraft.fire_coral_fan": "fã coral do fogo",
  "block.minecraft.horn_coral_fan": "fã coral do chifre",
  "block.minecraft.dead_tube_coral_fan": "doodbuis koraal fan",
  "block.minecraft.dead_brain_coral_fan": "fã de coral cérebro morto",
  "block.minecraft.dead_bubble_coral_fan": "fã de coral de bolha morta",
  "block.minecraft.dead_fire_coral_fan": "fã coral do fogo morto",
  "block.minecraft.dead_horn_coral_fan": "fã coral morto do chifre",
  "block.minecraft.blue_ice": "blou ys",
  "block.minecraft.conduit": "watervoor",
  "block.minecraft.polished_granite_stairs": "gepoleerde graniet trappe",
  "block.minecraft.smooth_red_sandstone_stairs": "rooi sandsteen trappe",
  "block.minecraft.mossy_stone_brick_stairs": "mossige klip baksteen trappe",
  "block.minecraft.polished_diorite_stairs": "gepoleerde dioriet trappe",
  "block.minecraft.mossy_cobblestone_stairs": "mossige geplaveide trappe",
  "block.minecraft.end_stone_brick_stairs": "eind baksteen trappe",
  "block.minecraft.stone_stairs": "steen trappe",
  "block.minecraft.smooth_sandstone_stairs": "gladde sandsteen trappe",
  "block.minecraft.smooth_quartz_stairs": "gladde kwarts trappe",
  "block.minecraft.granite_stairs": "graniet trappe",
  "block.minecraft.andesite_stairs": "andesiet trappe",
  "block.minecraft.red_nether_brick_stairs": "rooi laer baksteen trappe",
  "block.minecraft.polished_andesite_stairs": "gepoleerde andesiet trappe",
  "block.minecraft.diorite_stairs": "diorit trappe",
  "block.minecraft.polished_granite_slab": "gepoleerde graniet blad",
  "block.minecraft.smooth_red_sandstone_slab": "rooi sandsteen blad",
  "block.minecraft.mossy_stone_brick_slab": "mossige klip baksteen blad",
  "block.minecraft.polished_diorite_slab": "gepoleerde dioriet blad",
  "block.minecraft.mossy_cobblestone_slab": "mossige geplaveide blad",
  "block.minecraft.end_stone_brick_slab": "eind baksteen blad",
  "block.minecraft.smooth_sandstone_slab": "gladde sandsteen blad",
  "block.minecraft.smooth_quartz_slab": "gladde kwarts blad",
  "block.minecraft.granite_slab": "granietblad",
  "block.minecraft.andesite_slab": "andesiet blad",
  "block.minecraft.red_nether_brick_slab": "rooi laer baksteen blad",
  "block.minecraft.polished_andesite_slab": "gepoleerde andesiet blad",
  "block.minecraft.diorite_slab": "dioriet blad",
  "block.minecraft.scaffolding": "steierwerk",
  "block.minecraft.iron_door": "yster deur",
  "block.minecraft.oak_door": "eikehout deur",
  "block.minecraft.spruce_door": "dennehout deur",
  "block.minecraft.birch_door": "berkehout deur",
  "block.minecraft.jungle_door": "mahoniehout deur",
  "block.minecraft.acacia_door": "akasiahout deur",
  "block.minecraft.dark_oak_door": "donker eikehout deur",
  "block.minecraft.crimson_door": "bloedrooi deur",
  "block.minecraft.warped_door": "vreemde deur",
  "block.minecraft.repeater": "redstone versterker",
  "block.minecraft.comparator": "redstone vergelyker",
  "block.minecraft.structure_block": "struktuurblok",
  "block.minecraft.jigsaw": "legkaart blok",
  "item.minecraft.turtle_helmet": "skilpad dop□□wanneer dit op die kop is:□+2 wapenrusting",
  "item.minecraft.scute": "skub",
  "item.minecraft.iron_shovel": "yster graaf□□wanneer dit in die hoofhand is:□+3.5 aanval skade□-3 aanval spoed",
  "item.minecraft.iron_pickaxe": "yster pik□□wanneer dit in die hoofhand is:□+3 aanval skade□-2.8 aanval spoed",
  "item.minecraft.iron_axe": "yster byl□□wanneer dit in die hoofhand is:□+8 aanval skade□-3.1 aanval spoed",
  "item.minecraft.flint_and_steel": "aansteker",
  "item.minecraft.apple": "appel",
  "item.minecraft.bow": "boog",
  "item.minecraft.arrow": "pyl",
  "item.minecraft.coal": "steenkool",
  "item.minecraft.charcoal": "houtskool",
  "item.minecraft.diamond": "diamant",
  "item.minecraft.iron_ingot": "yster staaf",
  "item.minecraft.gold_ingot": "goud staaf",
  "item.minecraft.netherite_ingot": "netherietbaar",
  "item.minecraft.netherite_scrap": "laerietskroot",
  "item.minecraft.iron_sword": "yster swaard□□wanneer dit in die hoofhand is:□+5 aanval skade□-2.4 aanval spoed",
  "item.minecraft.wooden_sword": "hout swaard□□wanneer dit in die hoofhand is:□+3 aanval skade□-2.4 aanval spoed",
  "item.minecraft.wooden_shovel": "hout graaf□□wanneer dit in die hoofhand is:□+1.5 aanval skade□-3 aanval spoed",
  "item.minecraft.wooden_pickaxe": "hout pik□□wanneer dit in die hoofhand is:□+1 aanval skade□-2.8 aanval spoed",
  "item.minecraft.wooden_axe": "hout byl□□wanneer dit in die hoofhand is:□+6 aanval skade□-3.2 aanval spoed",
  "item.minecraft.stone_sword": "klip swaard□□wanneer dit in die hoofhand is:□+4 aanval skade□-2.4 aanval spoed",
  "item.minecraft.stone_shovel": "klip graaf□□wanneer dit in die hoofhand is:□+2.5 aanval skade□-3 aanval spoed",
  "item.minecraft.stone_pickaxe": "klip pik□□wanneer dit in die hoofhand is:□+2 aanval skade□-2.8 aanval spoed",
  "item.minecraft.stone_axe": "klip byl□□wanneer dit in die hoofhand is:□+8 aanval skade□-3.2 aanval spoed",
  "item.minecraft.diamond_sword": "diamant swaard□□wanneer dit in die hoofhand is:□+6 aanval skade□-2.4 aanval spoed",
  "item.minecraft.diamond_shovel": "diamant graaf□□wanneer dit in die hoofhand is:□+4.5 aanval skade□-3 aanval spoed",
  "item.minecraft.diamond_pickaxe": "diamant pik□□wanneer dit in die hoofhand is:□+4 aanval skade□-2.8 aanval spoed",
  "item.minecraft.diamond_axe": "diamant byl□□wanneer dit in die hoofhand is:□+8 aanval skade□-3 aanval spoed",
  "item.minecraft.stick": "stok",
  "item.minecraft.bowl": "hout bak",
  "item.minecraft.mushroom_stew": "sampioen bredie",
  "item.minecraft.golden_sword": "goue swaard□□wanneer dit in die hoofhand is:□+3 aanval skade□-2.4 aanval spoed",
  "item.minecraft.golden_shovel": "goue graaf□□wanneer dit in die hoofhand is:□+1.5 aanval skade□-3 aanval spoed",
  "item.minecraft.golden_pickaxe": "goue pik□□wanneer dit in die hoofhand is:□+1 aanval skade□-2.8 aanval spoed",
  "item.minecraft.golden_axe": "goue byl□□wanneer dit in die hoofhand is:□+6 aanval skade□-3 aanval spoed",
  "item.minecraft.netherite_sword": "laeriet swaard□□wanneer dit in die hoofhand is:□+7 aanval skade□-2.4 aanval spoed",
  "item.minecraft.netherite_shovel": "laeriet graaf□□wanneer dit in die hoofhand is:□+5.5 aanval skade□-3 aanval spoed",
  "item.minecraft.netherite_pickaxe": "laeriet pik□□wanneer dit in die hoofhand is:□+5 aanval skade□-2.8 aanval spoed",
  "item.minecraft.netherite_axe": "laeriet byl□□wanneer dit in die hoofhand is:□+9 aanval skade□-3 aanval spoed",
  "item.minecraft.string": "tou",
  "item.minecraft.feather": "veer",
  "item.minecraft.gunpowder": "buskruit",
  "item.minecraft.wooden_hoe": "hout skoffel□□wanneer dit in die hoofhand is:□-3 aanval spoed",
  "item.minecraft.stone_hoe": "klip skoffel□□wanneer dit in die hoofhand is:□-2 aanval spoed",
  "item.minecraft.iron_hoe": "yster skoffel□□wanneer dit in die hoofhand is:□-1 aanval spoed",
  "item.minecraft.diamond_hoe": "diamant skoffel□□wanneer dit in die hoofhand is:",
  "item.minecraft.golden_hoe": "goue skoffel□□wanneer dit in die hoofhand is:□-3 aanval spoed",
  "item.minecraft.netherite_hoe": "laerietskoffel□□wanneer dit in die hoofhand is:",
  "item.minecraft.wheat_seeds": "koring saad",
  "item.minecraft.wheat": "koring",
  "item.minecraft.bread": "brood",
  "item.minecraft.leather_helmet": "leer hoed□□wanneer dit op die kop is:□+1 wapenrusting",
  "item.minecraft.leather_chestplate": "leer harnas□□wanneer dit op die liggaam is:□+3 wapenrusting",
  "item.minecraft.leather_leggings": "leer broek□□wanneer dit op die bene is:□+2 wapenrusting",
  "item.minecraft.leather_boots": "leer stewels□□wanneer dit op die voete is:□+1 wapenrusting",
  "item.minecraft.chainmail_helmet": "ketting helm□□wanneer dit op die kop is:□+2 wapenrusting",
  "item.minecraft.chainmail_chestplate": "kettingposte borsplaat□□wanneer dit op die liggaam is:□+5 wapenrusting",
  "item.minecraft.chainmail_leggings": "ketting broek□□wanneer dit op die bene is:□+4 wapenrusting",
  "item.minecraft.chainmail_boots": "ketting stewels□□wanneer dit op die voete is:□+1 wapenrusting",
  "item.minecraft.iron_helmet": "yster helm□□wanneer dit op die kop is:□+2 wapenrusting",
  "item.minecraft.iron_chestplate": "yster borsplaat□□wanneer dit op die liggaam is:□+6 wapenrusting",
  "item.minecraft.iron_leggings": "yster kamaste□□wanneer dit op die bene is:□+5 wapenrusting",
  "item.minecraft.iron_boots": "yster stewels□□wanneer dit op die voete is:□+2 wapenrusting",
  "item.minecraft.diamond_helmet": "diamant helm□□wanneer dit op die kop is:□+3 wapenrusting□+2 wapenrusting taaiheid",
  "item.minecraft.diamond_chestplate": "diamant borsplaat□□wanneer dit op die liggaam is:□+8 wapenrusting□+2 wapenrusting taaiheid",
  "item.minecraft.diamond_leggings": "diamant kamaste□□wanneer dit op die bene is:□+6 wapenrusting□+2 wapenrusting taaiheid",
  "item.minecraft.diamond_boots": "diamant stewels□□wanneer dit op die voete is:□+3 wapenrusting□+2 wapenrusting taaiheid",
  "item.minecraft.golden_helmet": "goue helm□□wanneer dit op die kop is:□+2 wapenrusting",
  "item.minecraft.golden_chestplate": "goue borsplaat□□wanneer dit op die liggaam is:□+5 wapenrusting",
  "item.minecraft.golden_leggings": "goue kamaste□□wanneer dit op die bene is:□+3 wapenrusting",
  "item.minecraft.golden_boots": "goue stewels□□wanneer dit op die voete is:□+1 wapenrusting",
  "item.minecraft.netherite_helmet": "netheriethelm□□wanneer dit op die kop is:□+3 wapenrusting□+3 wapenrusting taaiheid□+1 terugstoot weerstand",
  "item.minecraft.netherite_chestplate": "laeriet borskasplaat□□wanneer dit op die liggaam is:□+8 wapenrusting□+3 wapenrusting taaiheid□+1 terugstoot weerstand",
  "item.minecraft.netherite_leggings": "laeriet broek□□wanneer dit op die bene is:□+6 wapenrusting□+3 wapenrusting taaiheid□+1 terugstoot weerstand",
  "item.minecraft.netherite_boots": "laeriet stewels□□wanneer dit op die voete is:□+3 wapenrusting□+3 wapenrusting taaiheid□+1 terugstoot weerstand",
  "item.minecraft.flint": "vuursteen",
  "item.minecraft.porkchop": "rou varktjop",
  "item.minecraft.cooked_porkchop": "gaar varktjop",
  "item.minecraft.painting": "skildery",
  "item.minecraft.golden_apple": "goue appel",
  "item.minecraft.enchanted_golden_apple": "enchanted golden apple",
  "block.minecraft.oak_sign": "eikenteken",
  "block.minecraft.spruce_sign": "spruitteken",
  "block.minecraft.birch_sign": "berkteken",
  "block.minecraft.jungle_sign": "jungle teken",
  "block.minecraft.acacia_sign": "akasiahoutteken",
  "block.minecraft.dark_oak_sign": "donker oak teken",
  "block.minecraft.crimson_sign": "bloedrooi bord",
  "block.minecraft.warped_sign": "vreemde bord",
  "item.minecraft.bucket": "emmer",
  "item.minecraft.water_bucket": "emmer water",
  "item.minecraft.lava_bucket": "emmer lawa",
  "item.minecraft.minecart": "koekepan",
  "item.minecraft.saddle": "saal",
  "item.minecraft.redstone": "redstone poeier",
  "item.minecraft.snowball": "sneeubal",
  "item.minecraft.oak_boat": "eikehout boot",
  "item.minecraft.leather": "leervel",
  "item.minecraft.milk_bucket": "melk emmer",
  "item.minecraft.pufferfish_bucket": "emmer blaasoppies",
  "item.minecraft.salmon_bucket": "emmer salm",
  "item.minecraft.cod_bucket": "emmer kabeljou",
  "item.minecraft.tropical_fish_bucket": "emmer tropiese visse",
  "item.minecraft.brick": "baksteen",
  "item.minecraft.clay_ball": "klei bal",
  "block.minecraft.dried_kelp_block": "uitgedroogde kelp blok",
  "item.minecraft.paper": "papier",
  "item.minecraft.book": "boek",
  "item.minecraft.slime_ball": "slymbal",
  "item.minecraft.chest_minecart": "koekepan met kis",
  "item.minecraft.furnace_minecart": "koekepan enjin",
  "item.minecraft.egg": "eier",
  "item.minecraft.compass": "kompas",
  "item.minecraft.fishing_rod": "visstok",
  "item.minecraft.clock": "horlosie",
  "item.minecraft.glowstone_dust": "gloeisteen poeier",
  "item.minecraft.cod": "rou kabeljou",
  "item.minecraft.salmon": "rou salm",
  "item.minecraft.tropical_fish": "tropiese vis",
  "item.minecraft.pufferfish": "blaasoppie",
  "item.minecraft.cooked_cod": "gaar kabeljou",
  "item.minecraft.cooked_salmon": "gebakde salm",
  "item.minecraft.ink_sac": "inksak",
  "item.minecraft.red_dye": "rooi kleurstof",
  "item.minecraft.green_dye": "groen kleurstof",
  "item.minecraft.cocoa_beans": "kakao bone",
  "item.minecraft.lapis_lazuli": "lasuur",
  "item.minecraft.purple_dye": "pers kleurstof",
  "item.minecraft.cyan_dye": "siaan kleurstof",
  "item.minecraft.light_gray_dye": "liggrys kleurstof",
  "item.minecraft.gray_dye": "grys kleurstof",
  "item.minecraft.pink_dye": "pienk kleurstof",
  "item.minecraft.lime_dye": "heldergroen kleurstof",
  "item.minecraft.yellow_dye": "geel kleurstof",
  "item.minecraft.light_blue_dye": "ligblou kleurstof",
  "item.minecraft.magenta_dye": "magenta kleurstof",
  "item.minecraft.orange_dye": "oranje kleurstof",
  "item.minecraft.bone_meal": "beenmeel",
  "item.minecraft.blue_dye": "blou kleurstof",
  "item.minecraft.brown_dye": "bruin kleurstof",
  "item.minecraft.black_dye": "swart kleurstof",
  "item.minecraft.white_dye": "wit kleurstof",
  "item.minecraft.bone": "been",
  "item.minecraft.sugar": "suiker",
  "block.minecraft.cake": "koek",
  "block.minecraft.white_bed": "wit bed",
  "block.minecraft.orange_bed": "oranje bed",
  "block.minecraft.magenta_bed": "magenta bed",
  "block.minecraft.light_blue_bed": "ligte blou bed",
  "block.minecraft.yellow_bed": "geel bed",
  "block.minecraft.lime_bed": "lemmetjie groen bed",
  "block.minecraft.pink_bed": "pienk bed",
  "block.minecraft.gray_bed": "grys bed",
  "block.minecraft.light_gray_bed": "ligte grys bed",
  "block.minecraft.cyan_bed": "siaan bed",
  "block.minecraft.purple_bed": "pers bed",
  "block.minecraft.blue_bed": "blou bed",
  "block.minecraft.brown_bed": "bruin bed",
  "block.minecraft.green_bed": "groen bed",
  "block.minecraft.red_bed": "rooi bed",
  "block.minecraft.black_bed": "swart bed",
  "item.minecraft.cookie": "beskuitjie",
  "item.minecraft.filled_map": "kaart□#0",
  "item.minecraft.shears": "skêr",
  "item.minecraft.melon_slice": "waatlemoenskyf",
  "item.minecraft.dried_kelp": "uitgedroogde kelp",
  "item.minecraft.pumpkin_seeds": "pampoensaad",
  "item.minecraft.melon_seeds": "waatlemoensaad",
  "item.minecraft.beef": "rou beesvleis",
  "item.minecraft.cooked_beef": "braaivleis",
  "item.minecraft.chicken": "rou hoender",
  "item.minecraft.cooked_chicken": "gebraaide hoender",
  "item.minecraft.rotten_flesh": "vrot vleis",
  "item.minecraft.ender_pearl": "ender pêrel",
  "item.minecraft.blaze_rod": "opvlammer staaf",
  "item.minecraft.ghast_tear": "ghast traan",
  "item.minecraft.gold_nugget": "goudklont",
  "item.minecraft.nether_wart": "netherwortel",
  "item.minecraft.potion": "onwerkbare doepa□geen effekte",
  "item.minecraft.glass_bottle": "glasbottel",
  "item.minecraft.spider_eye": "spinnekop oog",
  "item.minecraft.fermented_spider_eye": "gegisde spinnekop oog",
  "item.minecraft.blaze_powder": "opvlammer poeier",
  "item.minecraft.magma_cream": "magma room",
  "block.minecraft.brewing_stand": "retortstaander",
  "block.minecraft.cauldron": "kookpot",
  "item.minecraft.ender_eye": "endersoog",
  "item.minecraft.glistering_melon_slice": "glinsterende waatlemoenskyf",
  "item.minecraft.bat_spawn_egg": "vlermuis kuit eier",
  "item.minecraft.bee_spawn_egg": "by kuit eier",
  "item.minecraft.blaze_spawn_egg": "opvlammer kuit eier",
  "item.minecraft.cat_spawn_egg": "kat kuiteier",
  "item.minecraft.cave_spider_spawn_egg": "grotspinnekop eier",
  "item.minecraft.chicken_spawn_egg": "hoender kuit eier",
  "item.minecraft.cod_spawn_egg": "kabeljou kuit eier",
  "item.minecraft.cow_spawn_egg": "kabeljou kuit eier",
  "item.minecraft.creeper_spawn_egg": "creeper kuit eier",
  "item.minecraft.dolphin_spawn_egg": "dolfyn kuit eier",
  "item.minecraft.donkey_spawn_egg": "donkie kuit eier",
  "item.minecraft.drowned_spawn_egg": "verdrinke kuiteier",
  "item.minecraft.elder_guardian_spawn_egg": "oerwag kuiteier",
  "item.minecraft.enderman_spawn_egg": "einderman kuit eier",
  "item.minecraft.endermite_spawn_egg": "eindemiet kuit eier",
  "item.minecraft.evoker_spawn_egg": "roepster kuit eier",
  "item.minecraft.fox_spawn_egg": "jakkals kuiteier",
  "item.minecraft.ghast_spawn_egg": "woeder kuit eier",
  "item.minecraft.guardian_spawn_egg": "voog kuit eier",
  "item.minecraft.hoglin_spawn_egg": "hoglin kuiteier",
  "item.minecraft.horse_spawn_egg": "perd kuit eier",
  "item.minecraft.husk_spawn_egg": "dorsling kuiteier",
  "item.minecraft.llama_spawn_egg": "llama kuit eier",
  "item.minecraft.magma_cube_spawn_egg": "magma kubus kuit eier",
  "item.minecraft.mooshroom_spawn_egg": "moepioen kuit eier",
  "item.minecraft.mule_spawn_egg": "pak donkie kuit eier",
  "item.minecraft.ocelot_spawn_egg": "kol kat kuit eier",
  "item.minecraft.panda_spawn_egg": "panada kuiteier",
  "item.minecraft.parrot_spawn_egg": "papegaai kuit eier",
  "item.minecraft.phantom_spawn_egg": "fantoom kuiteier",
  "item.minecraft.pig_spawn_egg": "vark kuit eier",
  "item.minecraft.piglin_spawn_egg": "piglin kuiteier",
  "item.minecraft.pillager_spawn_egg": "plunderaar kuiteier",
  "item.minecraft.polar_bear_spawn_egg": "ys beer kuit eier",
  "item.minecraft.pufferfish_spawn_egg": "opblaasvis kuit eier",
  "item.minecraft.rabbit_spawn_egg": "haas kuit eier",
  "item.minecraft.ravager_spawn_egg": "ravanger kuiteier",
  "item.minecraft.salmon_spawn_egg": "salm kuit eier",
  "item.minecraft.sheep_spawn_egg": "skaap kuit eier",
  "item.minecraft.shulker_spawn_egg": "skulploerkuiteier",
  "item.minecraft.silverfish_spawn_egg": "vismot kuit eier",
  "item.minecraft.skeleton_spawn_egg": "benemonster kuit eier",
  "item.minecraft.skeleton_horse_spawn_egg": "geraamte perd kuit eier",
  "item.minecraft.slime_spawn_egg": "slyk kuit eier",
  "item.minecraft.spider_spawn_egg": "spinnekop kuit eier",
  "item.minecraft.squid_spawn_egg": "inkvis kuit eier",
  "item.minecraft.stray_spawn_egg": "nagelaate kuit eier",
  "item.minecraft.strider_spawn_egg": "strider kuiteier",
  "item.minecraft.trader_llama_spawn_egg": "handelaar lama kuiteier",
  "item.minecraft.tropical_fish_spawn_egg": "tropiese vis kuit eier",
  "item.minecraft.turtle_spawn_egg": "skilpad kuit eier",
  "item.minecraft.vex_spawn_egg": "kwaad doenertjie kuit eier",
  "item.minecraft.villager_spawn_egg": "inwoner kuit eier",
  "item.minecraft.vindicator_spawn_egg": "handhawer kuiteier",
  "item.minecraft.wandering_trader_spawn_egg": "dwaalhandelaar kuiteier",
  "item.minecraft.witch_spawn_egg": "heks kuit eier",
  "item.minecraft.wither_skeleton_spawn_egg": "donker geraamte kuit eier",
  "item.minecraft.wolf_spawn_egg": "wolf kuit eier",
  "item.minecraft.zoglin_spawn_egg": "zoglin kuiteier",
  "item.minecraft.zombie_spawn_egg": "zombie kuit eier",
  "item.minecraft.zombie_horse_spawn_egg": "zombie perd kuit eier",
  "item.minecraft.zombie_villager_spawn_egg": "zombie inwoner kuit eier",
  "item.minecraft.zombified_piglin_spawn_egg": "gezombifeerde piglin kuiteier",
  "item.minecraft.experience_bottle": "bottel van betowering",
  "item.minecraft.fire_charge": "vuurbal",
  "item.minecraft.writable_book": "boek en pen",
  "item.minecraft.written_book": "geskrewe boek",
  "item.minecraft.emerald": "smarag",
  "item.minecraft.item_frame": "voorwerp raam",
  "block.minecraft.flower_pot": "blompot",
  "item.minecraft.carrot": "wortel",
  "item.minecraft.potato": "aartappel",
  "item.minecraft.baked_potato": "gebakte aartappel",
  "item.minecraft.poisonous_potato": "giftige aartappel",
  "item.minecraft.map": "leë kaart",
  "item.minecraft.golden_carrot": "goue wortel",
  "block.minecraft.skeleton_skull": "geraamte skedel",
  "block.minecraft.wither_skeleton_skull": "wither geraamte skedel",
  "block.minecraft.player_head": "speler kop",
  "block.minecraft.zombie_head": "zombie kop",
  "block.minecraft.creeper_head": "creeper kop",
  "block.minecraft.dragon_head": "draak kop",
  "item.minecraft.carrot_on_a_stick": "wortel aan 'n stok",
  "item.minecraft.warped_fungus_on_a_stick": "vreemdefungus op 'n stok",
  "item.minecraft.nether_star": "nether ster",
  "item.minecraft.pumpkin_pie": "pampoen pastei",
  "item.minecraft.firework_rocket": "vuurpyl",
  "item.minecraft.firework_star": "vuurwerk ster",
  "item.minecraft.enchanted_book": "toorboek",
  "item.minecraft.nether_brick": "nether baksteen",
  "item.minecraft.quartz": "nether kwarts",
  "item.minecraft.tnt_minecart": "koekepan met tnt",
  "item.minecraft.hopper_minecart": "koekepan met geutbak",
  "item.minecraft.prismarine_shard": "prismaryn skerf",
  "item.minecraft.prismarine_crystals": "prismaryn kristalle",
  "item.minecraft.rabbit": "rou konyn",
  "item.minecraft.cooked_rabbit": "gaar konyn",
  "item.minecraft.rabbit_stew": "konyn bredie",
  "item.minecraft.rabbit_foot": "konyn poot",
  "item.minecraft.rabbit_hide": "konyn pels",
  "item.minecraft.armor_stand": "wapenrusting staander",
  "item.minecraft.iron_horse_armor": "yster perdharnas",
  "item.minecraft.golden_horse_armor": "goue perd beskerming",
  "item.minecraft.diamond_horse_armor": "diamant perdharnas",
  "item.minecraft.leather_horse_armor": "leer perd wapenrusting",
  "item.minecraft.lead": "leiriem",
  "item.minecraft.name_tag": "naamkaartjie",
  "item.minecraft.command_block_minecart": "koekepan met opdragblok",
  "item.minecraft.mutton": "rou skaapvleis",
  "item.minecraft.cooked_mutton": "gaar skaapvleis",
  "block.minecraft.white_banner": "wit banier",
  "block.minecraft.orange_banner": "oranje banier",
  "block.minecraft.magenta_banner": "purperrooi banier",
  "block.minecraft.light_blue_banner": "ligblou banier",
  "block.minecraft.yellow_banner": "geel banier",
  "block.minecraft.lime_banner": "heldergroen banier",
  "block.minecraft.pink_banner": "pienk banier",
  "block.minecraft.gray_banner": "grys banier",
  "block.minecraft.light_gray_banner": "ligtegrys vlag",
  "block.minecraft.cyan_banner": "siaan vlag",
  "block.minecraft.purple_banner": "pers vlag",
  "block.minecraft.blue_banner": "blou vlag",
  "block.minecraft.brown_banner": "bruin banier",
  "block.minecraft.green_banner": "groen banier",
  "block.minecraft.red_banner": "rooi banier",
  "block.minecraft.black_banner": "swart banier",
  "item.minecraft.end_crystal": "end kristal",
  "item.minecraft.chorus_fruit": "refrein vrug",
  "item.minecraft.popped_chorus_fruit": "gepofte refrein vrug",
  "item.minecraft.beetroot": "beet",
  "item.minecraft.beetroot_seeds": "beet saadjies",
  "item.minecraft.beetroot_soup": "beet sop",
  "item.minecraft.dragon_breath": "draak asem",
  "item.minecraft.splash_potion": "onmaakbare spatdoepa□geen effekte",
  "item.minecraft.spectral_arrow": "spektrale pyl",
  "item.minecraft.tipped_arrow": "onmaakbare gedoopte pyl□geen effekte",
  "item.minecraft.lingering_potion": "onwerkbare draaldoepa□geen effekte",
  "item.minecraft.shield": "skild",
  "item.minecraft.elytra": "elytra",
  "item.minecraft.spruce_boat": "dennehout boot",
  "item.minecraft.birch_boat": "berkehout boot",
  "item.minecraft.jungle_boat": "mahoniehout boot",
  "item.minecraft.acacia_boat": "akasiahout boot",
  "item.minecraft.dark_oak_boat": "donker eikehout boot",
  "item.minecraft.totem_of_undying": "totem van ewig",
  "item.minecraft.shulker_shell": "skulploerskulp",
  "item.minecraft.iron_nugget": "yster klont",
  "item.minecraft.knowledge_book": "kennis boek",
  "item.minecraft.debug_stick": "debug stok",
  "item.minecraft.music_disc_13": "musiekplaat□c418 - 13",
  "item.minecraft.music_disc_cat": "musiekplaat□c418 - cat",
  "item.minecraft.music_disc_blocks": "musiekplaat□c418 - blocks",
  "item.minecraft.music_disc_chirp": "musiekplaat□c418 - chirp",
  "item.minecraft.music_disc_far": "musiekplaat□c418 - far",
  "item.minecraft.music_disc_mall": "musiekplaat□c418 - mall",
  "item.minecraft.music_disc_mellohi": "musiekplaat□c418 - mellohi",
  "item.minecraft.music_disc_stal": "musiekplaat□c418 - stal",
  "item.minecraft.music_disc_strad": "musiekplaat□c418 - strad",
  "item.minecraft.music_disc_ward": "musiekplaat□c418 - ward",
  "item.minecraft.music_disc_11": "musiekplaat□c418 - 11",
  "item.minecraft.music_disc_wait": "musiekplaat□c418 - wait",
  "item.minecraft.music_disc_pigstep": "musiekplaat□lena raine - pigstep",
  "item.minecraft.trident": "drietand□□wanneer dit in die hoofhand is:□+8 aanval skade□-2.9 aanval spoed",
  "item.minecraft.phantom_membrane": "spook membraan",
  "item.minecraft.nautilus_shell": "nautilus skulp",
  "item.minecraft.heart_of_the_sea": "hart van die sea",
  "item.minecraft.crossbow": "kruisboog",
  "item.minecraft.suspicious_stew": "verdagte bredie",
  "block.minecraft.loom": "weefstoel",
  "item.minecraft.flower_banner_pattern": "banier patroon□blom lading",
  "item.minecraft.creeper_banner_pattern": "banier patroon□creeper beheer",
  "item.minecraft.skull_banner_pattern": "banier patroon□skedel lading",
  "item.minecraft.mojang_banner_pattern": "banier patroon□ding",
  "item.minecraft.globe_banner_pattern": "banier patroon□werêldbol",
  "item.minecraft.piglin_banner_pattern": "banier patroon□snoet",
  "block.minecraft.composter": "komposmaker",
  "block.minecraft.barrel": "vat",
  "block.minecraft.smoker": "rookoond",
  "block.minecraft.blast_furnace": "hoogoond",
  "block.minecraft.cartography_table": "kartografie tafel",
  "block.minecraft.fletching_table": "fletching tafel",
  "block.minecraft.grindstone": "slypsteen",
  "block.minecraft.lectern": "lessenaar",
  "block.minecraft.smithing_table": "smithing tafel",
  "block.minecraft.stonecutter": "klipsnyer",
  "block.minecraft.bell": "klok",
  "block.minecraft.lantern": "lantern",
  "block.minecraft.soul_lantern": "siellantern",
  "item.minecraft.sweet_berries": "soetbessies",
  "block.minecraft.campfire": "kampvuur",
  "block.minecraft.soul_campfire": "siel kampvuur",
  "block.minecraft.shroomlight": "sampioenlig",
  "item.minecraft.honeycomb": "heuningkoek",
  "block.minecraft.bee_nest": "byenes",
  "block.minecraft.beehive": "byekorf",
  "item.minecraft.honey_bottle": "heuning bottel",
  "block.minecraft.honey_block": "heuningblok",
  "block.minecraft.honeycomb_block": "heuningkoekblok",
  "block.minecraft.lodestone": "seilsteen",
  "block.minecraft.netherite_block": "blok van laeriet",
  "block.minecraft.ancient_debris": "oer puin",
  "block.minecraft.target": "teiken",
  "block.minecraft.crying_obsidian": "huilende obsidiaan",
  "block.minecraft.blackstone": "swartsteen",
  "block.minecraft.blackstone_slab": "swartsteenblad",
  "block.minecraft.blackstone_stairs": "swartsteentrappe",
  "block.minecraft.gilded_blackstone": "vergulde swartsteen",
  "block.minecraft.polished_blackstone": "gepoleerde swartsteen",
  "block.minecraft.polished_blackstone_slab": "gepoleerde swartsteenblad",
  "block.minecraft.polished_blackstone_stairs": "gepoleerde swartsteentrappe",
  "block.minecraft.chiseled_polished_blackstone": "afgewerkte gepoleerde swartsteen",
  "block.minecraft.polished_blackstone_bricks": "gepoleerde swartsteen bakstene",
  "block.minecraft.polished_blackstone_brick_slab": "gepoleerde swartsteen baksteenblad",
  "block.minecraft.polished_blackstone_brick_stairs": "gepoleerde swartsteen baksteentrappe",
  "block.minecraft.cracked_polished_blackstone_bricks": "gekraakte gepoleerde swartsteen bakstene",
  "block.minecraft.respawn_anchor": "hervestigingsanker",
}
export const af_za = items; 
